import React, { useEffect, useState, useCallback, useRef } from 'react';
import classNames from 'classnames/bind';
import styles from './SwipeMenu.module.scss';

const cx = classNames.bind(styles);

const SwipeMenu = ({ children = null, startIndex = 0, height = 50, wide = false }) => {
	const [swipe, setSwipe] = useState(false);
	const [move, setMove] = useState(false);
	const [scroll, setScroll] = useState(0);
	const [startX, setStartX] = useState(0);
	const swipeEl = useRef(null);
	const swipeContainerEl = useRef(null);
	const setStartLeft = useCallback((index) => {
		const startIndexLeft = swipeContainerEl.current.children[index].offsetLeft;
		const childStyle = getComputedStyle(swipeContainerEl.current.children[0]);
		const itemMargin = parseInt(childStyle.getPropertyValue('padding-left'), 10) || parseInt(childStyle.getPropertyValue('margin-left'), 10);
		swipeEl.current.scrollLeft = startIndexLeft - parseInt(itemMargin, 10);
	}, []);

	useEffect(() => {
		if (swipeContainerEl.current.children[startIndex]) setStartLeft(startIndex);
	}, [startIndex, setStartLeft]);

	const onMouseDown = useCallback(
		(e) => {
			e.preventDefault();
			setStartX(e.pageX);
			setSwipe(true);
			setScroll(swipeEl.current.scrollLeft);
		},
		[swipeEl],
	);

	const onMouseMove = useCallback(
		(e) => {
			if (!swipe) return;
			if (Math.abs(startX - e.pageX) > 8) {
				setMove(true);
			} else {
				setMove(false);
			}
			e.preventDefault();
			const result = scroll + startX - e.pageX;
			swipeEl.current.scrollLeft = result;
		},
		[swipe, scroll, swipeEl, startX],
	);

	const onMouseUp = useCallback(() => {
		const items = swipeContainerEl.current.children;
		setSwipe(false);
		Object.keys(items).forEach((key) => {
			items[key].onclick = (e) => {
				if (move) {
					if (e.target.tagName === 'LABEL' || e.target.tagName === 'BUTTON') e.stopPropagation();
					return false;
				}
				return true;
			};
		});
		setMove(false);
	}, [move]);

	const onMouseLeave = useCallback(() => {
		setSwipe(false);
	}, []);
	return (
		<div
			className={cx('swipe')}
			style={{
				height: `${height}px`,
			}}
		>
			{/* eslint-disable-next-line jsx-a11y/interactive-supports-focus */}
			<div
				role="button"
				className={cx('inner')}
				style={{
					height: `${height + 17}px`,
				}}
				onMouseDown={onMouseDown}
				onMouseMove={onMouseMove}
				onMouseUp={onMouseUp}
				onMouseLeave={onMouseLeave}
				ref={swipeEl}
				data-testid="swipe_menu"
			>
				<div
					className={cx('swipe_container', { swipe_wide: wide })}
					ref={swipeContainerEl}
					data-testid="swipe_menu_container"
				>
					{children}
				</div>
			</div>
		</div>
	);
};

export default SwipeMenu;
